import { Form, FormItem } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  gap: 1rem;
`;

export const StyledFormItem = styled(FormItem)`
  &&& .ant-form-item-label {
    padding: 0;

    label {
      ${pickThemeFontStyles('12', '18', 'NORMAL')};
      color: ${COLORS.GRAY_MEDIUM};
      margin: 0 0 0.1rem;
    }
  }

  &&& textarea {
    resize: none;
  }
`;
